var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-edit-redirect"},[_c('a-spin',{attrs:{"size":"large"}}),_c('p',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }